import React from 'react';

import PageContainer from '../../js/components/PageContainer';
import Page from '../../js/pages/LoginPage';

export default function LoginPage() {
  return <Page />;
}

LoginPage.getLayout = (page) => (
  <PageContainer minimalHeader minimalFooter>
    {page}
  </PageContainer>
);

export async function getServerSideProps({req, query}) {
  if (req.user) { // if user is already logged in
    const returnPath = query.returnPath || '/home';
    return {
      redirect: {
        destination: returnPath,
        permanent: false,
      },
    };
  }

  return {
    props: {},
  };
}
